export const AGED_DEBT_STATISTICS = 'AGED_DEBT_STATISTICS'
export const AGED_DEBT_STATISTICS_SUCCESS = 'AGED_DEBT_STATISTICS_SUCCESS'
export const AGED_DEBT_STATISTICS_FAILED = 'AGED_DEBT_STATISTICS_FAILED'
export const CLEAR_AGED_DEBT_STATISTICS = 'CLEAR_AGED_DEBT'
